// src/components/PhoneFieldIntl.jsx
import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import allowed from "../data/allowedCountries";
import "../styles/theme.css";

export default function PhoneFieldIntl({ valueE164, onChangeE164, disabled = false, autoFocus = false }) {
	return (
		<div className={`yhs-phone${disabled ? " isDisabled" : ""}`}>
			<label className="label" htmlFor="phone-input" style={{ color: "#e5e7eb" }}>
				Phone number
			</label>
			<PhoneInput
				/* Hide the generic "International" option */
				addInternationalOption={false}
				defaultCountry="US"
				countries={allowed}
				value={valueE164 || ""}
				onChange={onChangeE164}
				disabled={disabled}
				autoFocus={autoFocus}
				placeholder="Enter your phone number"
				className="yhs-phone"
				autoComplete="tel"
				numberInputProps={{
					// CRITICAL: iOS autofill attributes for phone number detection
					id: "phone-input",
					name: "tel", // iOS specifically looks for name="tel" for phone autofill
					type: "tel", // Ensures mobile keyboard shows number pad
					autoComplete: "tel", // Standard autocomplete for phone numbers
					inputMode: "tel", // Explicitly request telephone input mode on iOS
				}}
			/>
		</div>
	);
}
